// components/configurations/LinkConfiguration.tsx
import React from 'react';
import { ColorField } from 'components/fields/ColorField/ColorField';
import { RadioField } from 'components/fields/RadioField/RadioField';
import ExpandableSection from 'components/ExpandableSection/ExpandableSection';
import SizeField from '../../SizeField/SizeField';

interface LinkConfigurationProps {
    localConfig: any;
    selectedTab: string;
    handleChange: (field: string, value: any) => void;
    getFieldValues: (field: string) => any;
}

const LinkConfiguration: React.FC<LinkConfigurationProps> = ({
    localConfig,
    selectedTab,
    handleChange,
    getFieldValues
}) => {
    return (
        <>
            {/* Aquí irá la configuración específica del componente Link */}
        </>
    );
};

export default LinkConfiguration;
